/* eslint no-nested-ternary: "off" */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { QuestionCircle } from 'styled-icons/fa-regular';
import Tooltip from '../common/components/Tooltip';
import Skeleton from './Skeleton';

const Card = ({
  'data-testid': testId,
  icon,
  type,
  title,
  tooltip,
  children,
  isLoading,
  bordered,
  className,
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const classNameByType = useMemo(() => {
    if (bordered) {
      let str = 'border ';
      switch (type) {
        case 'danger':
          str += 'border-danger-500 ring-1 ring-danger-500';
          break;
        case 'success':
          str += 'border-success ring-1 ring-success';
          break;
        case 'warning':
          str += 'border-warning ring-1 ring-warning';
          break;
        case 'info':
          str += 'border-info ring-1 ring-info';
          break;
        default:
          str += 'border-divider';
          break;
      }
      return str;
    }

    return 'shadow';
  }, [type, bordered]);

  return (
    <div
      data-testid={testId}
      className={`z-card p-4 bg-surface ${classNameByType} rounded-md ${className}`}
    >
      {title ? (
        <div className="z-card__header stack-4 h-full">
          {isLoading ? (
            <Skeleton className="h-6" />
          ) : (
            <div className="flex justify-between">
              <div className="cluster-2 items-center">
                {icon}
                <p className="font-medium truncate">{title}</p>
              </div>
              {tooltip && (
                <Tooltip title={tooltip}>
                  <QuestionCircle size="1em" className="ml-2" />
                </Tooltip>
              )}
            </div>
          )}
          {/* TODO: Separator style by design */}
          <hr />
          <div className="flex-1">
            {isLoading ? <Skeleton className="h-full" /> : children}
          </div>
        </div>
      ) : isLoading ? (
        <Skeleton className="h-full" />
      ) : (
        children
      )}
    </div>
  );
};

Card.propTypes = {
  'data-testid': PropTypes.string,
  type: PropTypes.oneOf(['danger', 'warning', 'success', 'info', 'neutral']),
  icon: PropTypes.node,
  title: PropTypes.string,
  tooltip: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  bordered: PropTypes.bool,
};

Card.defaultProps = {
  'data-testid': null,
  type: 'neutral',
  icon: null,
  title: null,
  tooltip: null,
  isLoading: false,
  className: '',
  bordered: true,
};

export default Card;
